import { trackClick } from "@tracking/tracking";
import {
  screenNames,
  useScreenActions,
  useScreenState,
} from "clientState/AuthFlow/providers/ScreenProvider";
import { useTracking } from "@edreamsodigeo/frontend-core";

import type { UseNewsletterOption } from "./contract";

export const useNewsletterOption = (): UseNewsletterOption => {
  const { trackEvent } = useTracking();
  const { toggleNewsletter } = useScreenActions();
  const { state } = useScreenState();

  const { AUTH_METHODS } = screenNames;

  const handleChangeAcceptsNewsLetter = (): void => {
    trackClick({
      trackEvent,
      screen: AUTH_METHODS,
      prefix: state.trackingPrefix,
    });
    toggleNewsletter();
  };

  return {
    handleChangeAcceptsNewsLetter,
  };
};
